import { type FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useRootSelector } from "@ds/hooks";

import { ASSETS_AUDIO_SEGMENT, ASSETS_IMAGES_SEGMENT, ASSETS_VIDEOS_SEGMENT } from "@ds/constants/router";

import { AssetsMainPage } from "./assets-main-page";
import { selectCurrentAssetsView } from "./redux/selectors";

const AssetsRouteSwitch = () => {
  const currentView = useRootSelector(selectCurrentAssetsView);
  if (currentView) {
    return <Navigate to={currentView} replace />;
  }

  return <Navigate to={ASSETS_VIDEOS_SEGMENT} replace />;
};

export const AssetsRouter: FC = () => (
  <Routes>
    <Route path="*" element={<AssetsRouteSwitch />} />
    <Route path={ASSETS_VIDEOS_SEGMENT} element={<AssetsMainPage />} />
    <Route path={ASSETS_IMAGES_SEGMENT} element={<AssetsMainPage />} />
    <Route path={ASSETS_AUDIO_SEGMENT} element={<AssetsMainPage />} />
  </Routes>
);
